import { apiClient } from '../../../gateways/api'
import type { LinkedProjects } from '../types/LinkedProjects'

export { fetchLinkedProjectsForEntity }

const fetchLinkedProjectsForEntity = async (entityId: string) => {
  const { data } = await apiClient<LinkedProjects>({
    url: `/rest/project/${entityId}/koppelingen`,
  })

  return data
}
